module.exports = __webpack_public_path__ + "media/images/lb/361-a4b341019e5a4bed6a5d028e49b8ad7d.svg";